/**
 * Body-only scroll lock for AI modals.
 * Adds/removes a single class on document.body and sets inline styles on body.
 * No classes on html or #app; layout-specific rules belong in MainLayout/MainLayoutNew.
 */

export const AI_SCENE_MODAL_OPEN_CLASS = 'ai-scene-modal-open';

let lockedScrollY = 0;

export function applyScrollLock(): number {
	const body = document.body;
	body.classList.add(AI_SCENE_MODAL_OPEN_CLASS);
	lockedScrollY = window.scrollY || window.pageYOffset || 0;
	body.style.position = 'fixed';
	body.style.top = `-${lockedScrollY}px`;
	body.style.left = '0';
	body.style.right = '0';
	body.style.width = '100%';
	return lockedScrollY;
}

export function clearScrollLock(restoreScroll: boolean, scrollY: number = lockedScrollY): void {
	const body = document.body;
	body.classList.remove(AI_SCENE_MODAL_OPEN_CLASS);
	body.style.position = '';
	body.style.top = '';
	body.style.left = '';
	body.style.right = '';
	body.style.width = '';
	if (restoreScroll && scrollY >= 0) {
		window.scrollTo(0, scrollY);
	}
}
